import _ from 'lodash';
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Layout, Icon } from 'antd';

import HeaderEditorPC from '../header/header.editor.pc';
import HeaderEditorWeb from '../header/header.editor.web';
import Copyright from '../copyright/copyright';
import MScratch from '../mscratch/mscratch';
// import NotServer from '../notserver/notserver';
import { isWeb } from '../../util/env';
import CONSTANT from '../../constant';

import RouterConfig from './route.config';

import { detectWebGLContext } from '../../util';
import { trackPage } from '../../util/analytics';
import config from '../../config';
import mElectronApi from '../../util/electron';
import History from '../../util/history';
import './app.less';
import AppList from './applist';

import DataChart from '../chart/index';

class App extends React.Component {

    constructor(props) {
        super(props);
        this.webglDetected = false;

        return this;
    }

    componentDidMount() {
        trackPage('/');
        const { project, location } = this.props;
        this.loading(project, location.pathname);
    }

    componentWillReceiveProps(nextProps) {
        const { project, location } = nextProps;
        this.loading(project, location.pathname);
    }

    loading(project, pathname) {
        if (pathname === '/' && project.projectStatus === CONSTANT.PROJECT_STATUS.WILL_DOWNLOAD) {
            History.replace('/loading');
        }
    }

    editor() {
        return (
            <Layout className="root-layout">
                {/* 导航 */}
                {this.header()}
                {/* 没有服务提示 */}
                {/* {this.notserver()} */}
                {/* mscratch 实例 */}
                <MScratch />
                {/* 其他页面路由 */}
                {this.routers()}
                {/* 保存文件导出使用的链接 */}
                {this.downloadLink()}
                {/* webgl 检测 */}
                {this.webgl()}
                { config.showCopyrightLogo ? <Copyright /> : '' }
                {/* 数据图表拓展窗口 */}
                { this.props.dataChart.show ? <DataChart /> : '' }
            </Layout>
        );
    }

    render() {
        return (
            <Layout className="root-layout">
                <Route path="/" render={() => this.editor()} />
                {
                    isWeb() ? null : <Route path="/list" component={AppList} />
                }
            </Layout>
        );
    }

    header() {
        if(!config.showHeader) return '';
        return (isWeb()
            ? <HeaderEditorWeb />
            : <HeaderEditorPC />
        );
    }

    routers() {
        const { account, location } = this.props;
        return (
            RouterConfig.map(config => {
                if (config.isPrivate) {
                    if (!account.isLogin) {
                        return (
                            <Redirect key={config.url} to={{
                                pathname: '/login',
                                state: { from: location }
                            }} />
                        );
                    }
                }
                return (
                    <Route exact={config.exact} key={config.url}
                        path={config.url}
                        component={config.component} />
                );
            })
        );
    }

    downloadLink() {
        return (
            <a id="DownloadFileTarget" style={{ visibility: 'hidden', zIndex: -100, position: 'absolute' }}></a>
        );
    }

    webgl() {
        if (this.webglDetected) {
            return;
        }
        if (!detectWebGLContext()) {
            const { intlr } = this.props;
            const link = config.link.faq[_.has(config.link.faq, intlr.langKey) ? intlr.langKey : 'en'];
            return (
                <section style={{
                    position: 'fixed',
                    zIndex: 2001,
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    backgroundColor: 'rgba(255, 255, 255, .75)',
                    fontSize: '2rem'
                }}>
                    <Icon style={{ fontSize: '200%' }} type="meh-o" />
                    <a href={link}
                        rel="nofollow me noopener noreferrer"
                        target="_blank"
                        onClick={(e) => mElectronApi.openLink(e, link)}>
                        <p style={{ margin: '2rem' }}>{intlr.messages['WEBGL.NOT.SUPPORT']}</p>
                    </a>
                </section>
            );
        }
        this.webglDetected = true;
    }
}

const mapStateToProps = state => ({
    account: state.account,
    intlr: state.intlr,
    project: state.project,
    dataChart: state.dataChart
});

export default connect(
    mapStateToProps,
)(App);